import { BrowserRouter as ReactRouter, Redirect, Route, Switch } from 'react-router-dom';
import React from 'react';

// @ts-ignore
import Home from './containers/Home';
import Login from './containers/Login';
import Markers from './containers/GoogleMap/Markers';

interface OwnProps {
}

type Props = OwnProps;

function Router(props: Props) {
	const [authToken] = React.useState(localStorage.getItem('token'));

	return (
		<ReactRouter>
			{!authToken ? (
				<Switch>
					<Route
						exact={true}
						path="/Login"
						component={Login}
					/>
					<Redirect
						from="*"
						to="/login"
					/>
				</Switch>
			) : (
					<Switch>
						<Route
							exact={true}
							path="/"
							component={Home}
						/>
						<Route
							exact={true}
							path="/allLocations"
							component={Markers}
						/>
						<Route render={() => <Redirect to="/" />} />
					</Switch>
				)}
		</ReactRouter>
	);
}

export default Router;
